<template>
    <button
        :class="['c-button', { 'c-button--round': round }, 'c-button--' + color]"
        :style="{ 'background-color': bgColor }"
        type="button"
    >
        <slot></slot>
    </button>
</template>

<script>
export default {
    props: {
        color: {
            type: String,
            validator: (val) => {
                return ['purple', 'orange', 'green', 'deep-orange'].includes(val);
            }
        },
        round: {
            type: Boolean,
            default: true
        },
        bgColor: {
            type: String,
            default: ''
        }
    }
};
</script>

<style lang="scss">
.c-button {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    color: #ffffff;
    appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: none;
    margin: 0;
    transition: 0.1s;
    font-weight: 500;
    user-select: none;
    padding: 14px 26px;
    font-size: 18px;
    border: 0;
    &--round {
        border-radius: 2000px;
    }
    &--purple {
        background: linear-gradient(-3deg, #89009a, #a60aac);
        box-shadow: 0px 5px 18px 0px #d594de;
    }
    &--orange {
        background: linear-gradient(-3deg, #ffb11a, #ffc61a);
        box-shadow: 0px 5px 18px 0px #ffc8a4;
    }
    &--deep-orange {
        background: linear-gradient(-3deg, #ff871d, #ff9e1d);
    }
    &--green {
        background: linear-gradient(-84deg, #0aa66a, #33ba86);
    }
    &:active,
    &:focus,
    &:visited {
        outline: none;
    }
}
</style>
